var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 547,
    viewBox: "0 0 638 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.099 450.65C109.886 457.725 109.006 444.701 112.508 428.768C116.01 412.833 122.007 419.297 122.007 419.297",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 434.373L117.978 429.87",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.058 424.474C127.058 424.474 120.494 438.044 130.388 443.813",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.365 420.658C136.365 420.658 147.198 426.676 140.412 439.702",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.942 429.071L136.703 434.738",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.029 426.576L128.956 436.243",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2704 352.106C85.7472 343.105 79.6474 334.611 70.6462 333.134C61.6449 331.657 53.1508 337.757 51.674 346.758C50.1972 355.759 56.297 364.253 65.2982 365.73C74.2995 367.207 82.7936 361.107 84.2704 352.106Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.097 370.769C92.8756 376.673 81.4252 374.794 75.5206 366.573C69.616 358.352 71.4949 346.902 79.7159 340.997C87.9369 335.093 99.3873 336.972 105.292 345.193C111.196 353.414 109.318 364.864 101.097 370.769Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0254 342.623L75.4115 345.341",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0822 345.762L73.1511 349.715",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4879 349.541L72.2866 354.233",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6204 354.707L72.4985 359.789",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6613 358.681L73.1996 362.19",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9535 324.274C75.4751 322.838 70.1216 321.821 69.8597 325.783C69.5993 329.747 75.5099 326.454 77.1677 324.343C77.1677 324.343 74.1276 328.426 75.4176 329.232",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.601 329.212L100.845 339.096C100.845 339.096 103.224 334.154 105.767 334.607C108.901 335.164 106.819 340.29 103.03 338.404",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141 538.565L148.469 545.632",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.469 536.719L142.214 546.062",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.814 539.4L163.286 536.624",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.868 528.834L171.412 532.855",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.894 524L169.141 543.747",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320 114.821L340.089 101L366.696 102.865L368.359 136.588L348.83 150.552L324.731 148.795L320 114.821Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M324.731 148.796L344.18 134.791L368.359 136.588",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M344.18 134.791L340.089 101",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320 114.821L346.548 117.896L366.696 102.865",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M346.548 117.896L348.83 150.552",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M546.233 264.596L537.332 292.256L565.035 288.518L546.233 264.596Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M546.233 264.596L551.184 290.226",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M550.39 286.119L553.63 285.604L554.386 289.955",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M189 472.908L202.844 479.707",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.375 467.719L194.414 482.178",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M200.296 460.67C200.296 460.67 202.247 458.909 203.631 461.097C205.015 463.283 202.296 467.851 202.296 467.851L207.848 465.739",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M268.73 1C281.942 8.42466 266.802 26.5927 266.802 37.1907C266.802 47.7887 281.942 46.2746 289.512 49.3026C292.54 49.3026 298.596 49.3027 298.433 57.0029",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M254 10.5957C256.297 23.1241 270.675 18.6789 279.47 21.5404C294.586 26.4579 286.206 42.0869 281.685 51.5282C278.983 57.1739 276.291 65.0634 281.122 70.4184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M255.933 15.4542L271.693 2.36108",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.117 19.3618L273.985 9.51782",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M269.09 29.3193L279.116 21.4435",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.02 41.1074L286.613 27.0166",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M274.524 46.6016L288.179 36.5759",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M280.334 67.9021L297.403 54.0051",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M280.757 56.9681L291.894 49.1422",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4486 258.16C84.709 251.657 92.6194 233.204 86.117 216.944C79.6146 200.684 61.1617 192.773 44.9014 199.276C28.641 205.778 20.7306 224.231 27.233 240.491C33.7354 256.752 52.1883 264.662 68.4486 258.16Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.671 198.026C75.7217 185.057 85.1191 177.707 88.7436 180.096C94.247 183.723 84.3591 208.43 66.6589 235.278C48.9587 262.127 30.1488 280.951 24.6469 277.323C21.0224 274.934 24.0746 263.399 31.6401 248.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6613 235.209C10.2578 230.776 0.415308 225.601 1.02696 221.463C1.99138 214.942 28.5621 213.472 60.3727 218.178C92.1849 222.883 117.192 231.984 116.226 238.505C115.558 243.015 102.644 245.109 84.2197 244.414",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7036 212.247C18.0791 191.266 12.2654 174.895 16.2093 172.341C21.3842 168.991 41.3963 190.7 60.9102 220.833C80.4241 250.965 92.0471 278.108 86.8723 281.46C83.4506 283.676 73.5354 274.928 61.5673 260.03",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2038 193.822C91.6187 196.226 88.3863 196.889 85.982 195.305C83.5778 193.72 82.9147 190.488 84.4983 188.084C86.0835 185.679 89.3159 185.016 91.7201 186.6C94.1243 188.185 94.789 191.418 93.2038 193.822Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9564 273.591C74.3712 275.996 71.1388 276.659 68.7346 275.075C66.3303 273.49 65.6672 270.258 67.2524 267.853C68.8375 265.449 72.0699 264.786 74.4742 266.37C76.8769 267.955 77.5415 271.189 75.9564 273.591Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1396 219.496C46.5545 221.9 43.3221 222.564 40.9178 220.98C38.5136 219.395 37.8505 216.162 39.4341 213.758C41.0193 211.354 44.2517 210.691 46.6559 212.276C49.0601 213.86 49.7248 217.092 48.1396 219.496Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M349.105 338.359L332.451 331.968L318.59 343.197L321.382 360.815L338.036 367.206L351.899 355.978L349.105 338.359Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M363.664 307.646L366.458 325.265L383.112 331.656",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M368.736 362.438L352.08 356.047L338.219 367.276L341.011 384.894L357.667 391.285L371.528 380.056L368.736 362.438Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M338.036 367.206L321.382 360.816L307.521 372.044L310.314 389.663L326.968 396.053L340.831 384.825L338.036 367.206Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M339.077 365.039C337.842 364.566 336.456 365.183 335.983 366.418C335.509 367.653 336.126 369.038 337.361 369.512C338.596 369.986 339.981 369.369 340.455 368.134C340.929 366.899 340.312 365.513 339.077 365.039Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M362.237 408.658C361.002 408.184 359.617 408.801 359.143 410.036C358.669 411.271 359.286 412.657 360.521 413.13C361.756 413.604 363.141 412.987 363.615 411.752C364.089 410.517 363.472 409.132 362.237 408.658Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M365.901 308.505C365.427 309.74 364.043 310.357 362.807 309.883C361.572 309.409 360.955 308.024 361.429 306.789C361.903 305.553 363.288 304.937 364.523 305.411C365.757 305.884 366.376 307.269 365.901 308.505Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M383.97 329.419C382.735 328.946 381.35 329.563 380.876 330.798C380.402 332.033 381.019 333.418 382.254 333.892C383.489 334.366 384.874 333.749 385.348 332.514C385.822 331.279 385.205 329.893 383.97 329.419Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M291.56 365.483C291.086 366.719 289.701 367.336 288.466 366.862C287.23 366.388 286.612 365.002 287.086 363.767C287.56 362.531 288.945 361.915 290.182 362.389C291.416 362.863 292.034 364.248 291.56 365.483Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M367.486 323.094C366.251 322.621 364.865 323.238 364.391 324.473C363.918 325.708 364.535 327.093 365.77 327.567C367.005 328.041 368.39 327.424 368.864 326.189C369.338 324.954 368.721 323.568 367.486 323.094Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M309.903 372.522C309.429 373.757 308.044 374.374 306.809 373.9C305.573 373.426 304.957 372.041 305.431 370.806C305.905 369.57 307.289 368.954 308.525 369.428C309.76 369.902 310.377 371.286 309.903 372.522Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M351.524 339.287C351.05 340.522 349.665 341.139 348.429 340.665C347.194 340.191 346.577 338.806 347.051 337.57C347.525 336.335 348.911 335.717 350.146 336.191C351.381 336.665 351.997 338.053 351.524 339.287Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M307.667 371.664L289.324 364.625",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M349.287 338.429L366.628 325.331",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M357.667 391.285L361.379 410.894",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M375.669 227.678C379.697 213.991 392.354 204 407.345 204C422.843 204 435.849 214.68 439.401 229.081",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M403.602 269.823C387.13 267.964 374.329 253.986 374.329 237.017",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M440.36 237.017C440.36 255.251 425.579 270.033 407.345 270.033",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M442.232 216.085C452.559 214.76 459.481 215.479 460.548 218.556C462.683 224.709 440.594 237.962 411.211 248.157C381.828 258.354 356.277 261.632 354.143 255.479C353.001 252.191 358.782 246.872 368.898 241.076",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M473.239 151L476.403 157.41L483.478 158.438L478.358 163.428L479.566 170.475L473.239 167.148L466.911 170.475L468.12 163.428L463 158.438L470.075 157.41L473.239 151Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M171.706 101.471C171.706 107.648 169.102 113.22 164.938 117.111C161.092 120.745 155.915 122.955 150.237 122.955C149.541 122.955 148.859 122.925 148.193 122.864C143.727 122.44 139.669 120.654 136.429 117.929C133.659 115.612 131.479 112.599 130.177 109.162C129.253 106.77 128.753 104.181 128.753 101.471C128.753 89.6167 138.367 80.0028 150.237 80.0028C153.568 80.0028 156.732 80.7598 159.563 82.1375C162.803 83.697 165.589 86.0437 167.663 88.9354C170.207 92.463 171.706 96.7931 171.706 101.471Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.258 105.356C168.258 107.191 166.771 108.678 164.936 108.678C163.101 108.678 161.615 107.191 161.615 105.356C161.615 103.521 163.101 102.035 164.936 102.035C166.771 102.035 168.258 103.521 168.258 105.356Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M138.367 113.795C138.367 115.461 137.61 116.944 136.429 117.928C133.659 115.612 131.479 112.599 130.177 109.162C130.979 108.663 131.933 108.39 132.947 108.39C135.945 108.39 138.367 110.813 138.367 113.795Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M164.938 117.111C161.092 120.745 155.915 122.955 150.237 122.955C149.541 122.955 148.859 122.925 148.193 122.864C148.072 122.289 148.011 121.698 148.011 121.093C148.011 116.157 152.008 112.145 156.944 112.145C160.457 112.145 163.485 114.174 164.938 117.111Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M145.03 92.9581C147.759 92.9581 149.971 90.7463 149.971 88.0179C149.971 85.2895 147.759 83.0778 145.03 83.0778C142.302 83.0778 140.09 85.2895 140.09 88.0179C140.09 90.7463 142.302 92.9581 145.03 92.9581Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M149.601 102.035C149.601 103.297 148.578 104.319 147.315 104.319C146.052 104.319 145.029 103.296 145.029 102.035C145.029 100.772 146.052 99.7484 147.315 99.7484C148.578 99.7484 149.601 100.773 149.601 102.035Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.663 88.9354C167.088 89.1323 166.452 89.2231 165.801 89.2231C162.319 89.2231 159.518 86.4071 159.518 82.9249C159.518 82.6523 159.533 82.395 159.563 82.1376C162.803 83.697 165.589 86.0437 167.663 88.9354Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M634.746 385.594L637.063 380.387L633.311 378.316C633.444 377.389 633.471 376.463 633.387 375.55L637.235 373.677L635.191 368.357L631.078 369.544C630.53 368.809 629.889 368.139 629.17 367.539L630.569 363.489L625.362 361.173L623.291 364.924C622.365 364.791 621.438 364.764 620.525 364.849L618.652 361L613.332 363.044L614.519 367.158C613.785 367.706 613.114 368.346 612.515 369.067L608.465 367.668L606.148 372.874L609.9 374.946C609.767 375.872 609.739 376.799 609.824 377.712L605.976 379.584L608.019 384.905L612.132 383.718C612.68 384.452 613.32 385.123 614.041 385.722L612.642 389.772L617.848 392.089L619.92 388.338C620.846 388.472 621.773 388.497 622.686 388.414L624.558 392.263L629.879 390.219L628.692 386.105C629.426 385.557 630.097 384.917 630.696 384.198L634.746 385.594ZM618.913 382.682C615.571 381.195 614.066 377.282 615.553 373.94C617.04 370.599 620.954 369.094 624.295 370.581C627.636 372.067 629.141 375.981 627.655 379.323C626.169 382.664 622.256 384.167 618.913 382.682Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M607.078 412.317L610.224 405.245L605.129 402.432C605.311 401.174 605.346 399.914 605.231 398.675L610.459 396.131L607.682 388.906L602.097 390.519C601.352 389.521 600.483 388.609 599.505 387.796L601.405 382.296L594.333 379.15L591.52 384.245C590.262 384.063 589.002 384.028 587.762 384.143L585.219 378.915L577.994 381.692L579.605 387.277C578.607 388.022 577.696 388.891 576.883 389.869L571.382 387.969L568.236 395.041L573.331 397.854C573.149 399.112 573.114 400.372 573.228 401.612L568 404.155L570.777 411.38L576.362 409.769C577.107 410.767 577.976 411.678 578.954 412.491L577.054 417.992L584.126 421.138L586.939 416.043C588.197 416.225 589.456 416.26 590.696 416.146L593.24 421.374L600.465 418.597L598.852 413.012C599.85 412.267 600.761 411.398 601.574 410.42L607.078 412.317ZM585.576 408.361C581.037 406.343 578.995 401.027 581.013 396.488C583.031 391.949 588.347 389.907 592.886 391.925C597.425 393.943 599.467 399.259 597.449 403.798C595.431 408.337 590.115 410.381 585.576 408.361Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/Elements.df3bb13d47c748149bd876b4637879a9.svg";
export { ForwardRef as ReactComponent };